<template>
  <div>
    <v-layout class="elevation-1" style="background-color: white" wrap>
      <v-col cols="6" sm="6" md="6">
        <v-layout wrap>
          <v-col cols="12" sm="12" md="12">
            <label class="label-modal">Brigadas</label>
            <v-select
              :color="$primary"
              :items="getBrigadas"
              v-model="brigada"
              item-value="id_brigada"
              item-text="nome"
              @change="change()"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-data-table
              v-model="selected"
              :headers="[{
                text: 'Nome',
                align: 'left',
                sortable: false,
                value: 'nome',
              }]"
              :items="getItems"
              item-key="nome"
              show-select
              class="elevation-0"
              :footer-props="{itemsPerPageText : 'Itens por página:', itemsPerPageOptions : [10,25,50], itemPerPageAllText: 'Todos'}"
              no-data-text="Não existem elementos para mostrar"
              no-results-text="Não foram encontrados resultados para a pesquisa"
            ></v-data-table>
          </v-col>
        </v-layout>
      </v-col>
      <v-col cols="6" sm="6" md="6">
        <v-form ref="notificacao">
          <v-layout wrap>
            <v-col cols="12" sm="12" md="12">
              <label class="label-modal">Título</label>
              <v-text-field
                :rules="[RULES.required]"
                :color="$primary"
                v-model="titulo"
                counter="100"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <label class="label-modal">Descrição</label>
              <v-textarea
                :rules="[RULES.required]"
                :color="$primary"
                v-model="descricao"
                no-resize
                counter="300"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="d-flex justify-space-between">
              <span>Destinatários: {{selected.length}}</span>
              <v-btn :loading="loading" dark @click="send()" :color="$primary">Enviar</v-btn>
            </v-col>
          </v-layout>
        </v-form>
      </v-col>
    </v-layout>
  </div>
</template>
<script>
import RULES from "@/mixins/_RULES"
export default {
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    },
    getItems() {
      return this.$store.getters["utilizador/getAll"].map(el => {
        return { id: el.id_utilizador, nome: el.nome }
      })
    },
    getBrigadas() {
      return this.$store.getters["brigada/getAll"]
    }
  },
  mixins: [RULES],
  data: () => ({
    selected: [],
    titulo: "",
    descricao: "",
    brigada: "",
    loading: false
  }),
  methods: {
    send() {
      if (!this.$refs.notificacao.validate() || this.selected.length == 0)
        return

      this.loading = true
      this.$store
        .dispatch("notificacao/notificacao", {
          titulo: this.titulo,
          descricao: this.descricao,
          instituicao: this.getSession.instituicao,
          to: this.selected.map(el => {
            return el.id
          })
        })
        .then(res => {
          this.loading = false
          if (res) {
            setTimeout(() => {
              this.$refs.notificacao.reset()
              this.selected = []
            }, 110)
            this.$toast.success("Notificação enviada com sucesso!")
          } else this.$toast.error("Ocorreu um erro ao enviar a notificação!")
        })
    },
    change() {
      this.$store
        .dispatch("brigada/getUtilizadoresBrigada", this.brigada)
        .then(res => {
          this.selected = [].concat(res)
        })
    }
  }
}
</script>